(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2996],{

/***/ 68057:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotions",
      function () {
        return __webpack_require__(69669);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94986);
/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88349);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88084);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_globals__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34885);
/* harmony import */ var _deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51493);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58709);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40300);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73764);
/* harmony import */ var _components_MetaTags__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39125);
/* harmony import */ var _deosite_components_new_InspirationsLandingBanner__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41012);
/* harmony import */ var _deosite_sections_ThreeInspirationBoxes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69231);
/* harmony import */ var _sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(44553);
/* harmony import */ var _deosite_api_hooks_prismic_usePrismicInspirationsLanding__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(37976);
/* harmony import */ var _deosite_components_new_Hit_HitHomePage__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(37038);














function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var PromotionsLanding = function(props) {
    var ref;
    var initialPrismicResponse = props.initialPrismicResponse, initialUid = props.initialUid, lang = props.lang;
    var translations = {
        seoDescription: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_4__["default"])("Default seo description"),
        seoTitle: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_4__["default"])("Default seo title")
    };
    var ref1 = (0,_deosite_api_hooks_prismic_usePrismicInspirationsLanding__WEBPACK_IMPORTED_MODULE_12__/* .usePrismicInspirationsLanding */ .GQ)(initialUid, lang, initialPrismicResponse), prismicResponse = ref1.data;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_MetaTags__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                description: (prismicResponse === null || prismicResponse === void 0 ? void 0 : prismicResponse.seoDescription) !== "" ? prismicResponse.seoDescription : translations.seoDescription,
                title: (prismicResponse === null || prismicResponse === void 0 ? void 0 : prismicResponse.seoTitle) !== "" ? prismicResponse.seoTitle : translations.seoTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                metaTagsData: {
                    description: translations.seoDescription,
                    title: translations.seoTitle
                },
                recentlyViewedActive: false,
                footerContent: props.footerContent,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_6___default()), {
                    sx: {
                        mt: [
                            "s10",
                            null,
                            null,
                            78,
                            null,
                            null
                        ]
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        title: prismicResponse === null || prismicResponse === void 0 ? void 0 : prismicResponse.title,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_6___default()), {
                            sx: {
                                mt: [
                                    "s10",
                                    null,
                                    null,
                                    78,
                                    null,
                                    null
                                ]
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default()), {
                                sx: {
                                    display: "flex",
                                    justifyContent: "center",
                                    flexDirection: "column"
                                },
                                children: prismicResponse === null || prismicResponse === void 0 ? void 0 : (ref = prismicResponse.content) === null || ref === void 0 ? void 0 : ref.map(function(element) {
                                    if (element.type === "banner") {
                                        var _backgroundColor, _textColor;
                                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_6___default()), {
                                            sx: {
                                                mb: [
                                                    "s10",
                                                    null,
                                                    null,
                                                    "s13"
                                                ]
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deosite_components_new_InspirationsLandingBanner__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                label: element.label,
                                                link: element.link,
                                                leftImage: element.leftImage,
                                                subtitle: element.subtitle,
                                                title: element.title,
                                                influencer: element.blogger,
                                                backgroundColor: (_backgroundColor = element.backgroundColor) !== null && _backgroundColor !== void 0 ? _backgroundColor : "#FAF8F6",
                                                textColor: (_textColor = element.textColor) !== null && _textColor !== void 0 ? _textColor : "#FAF8F6"
                                            })
                                        }));
                                    }
                                    if (element.type === "boxes") {
                                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_6___default()), {
                                            sx: {
                                                mb: [
                                                    "s10",
                                                    null,
                                                    null,
                                                    142
                                                ]
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deosite_sections_ThreeInspirationBoxes__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                link: element.url,
                                                boxes: element.boxes,
                                                label: element.label
                                            })
                                        }));
                                    }
                                })
                            })
                        })
                    })
                })
            })
        ]
    }));
};
PromotionsLanding.getInitialProps = (function() {
    var _ref = _asyncToGenerator(_usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(props) {
        var language, response;
        return _usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    language = props.language;
                    _ctx.next = 4;
                    return (0,_deosite_api_hooks_prismic_usePrismicInspirationsLanding__WEBPACK_IMPORTED_MODULE_12__/* .fetcher */ ._i)(__webpack_require__.g.__appConfig__.prismicPromotionsLandingUid, language);
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", {
                        initialPrismicResponse: response,
                        initialUid: "inspirationslanding",
                        lang: language
                    });
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error(_ctx.t0);
                    return _ctx.abrupt("return", _ctx.t0);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function(props) {
        return _ref.apply(this, arguments);
    };
})();
/* harmony default export */ __webpack_exports__["default"] = (PromotionsLanding);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9316,4745,8714,9774,2888,179], function() { return __webpack_exec__(68057); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);